import { HandCoins, Network, GraduationCap } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionLabel } from "./ui";
import { Reveal } from "./Reveal";

const ICONS = [HandCoins, Network, GraduationCap];

export const Benefits = () => {
  const { t } = useLang();
  const b = t.benefits;
  return (
    <section data-testid="benefits-section" className="py-16 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>{b.label}</SectionLabel>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold text-navy-900 leading-tight">{b.title}</h2>
        </Reveal>
        <div className="mt-10 grid sm:grid-cols-3 gap-4">
          {b.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={i * 0.07} className="h-full">
                <div className="h-full rounded-2xl border border-navy-100 bg-white p-6 shadow-[0_2px_12px_rgba(6,16,32,0.05)] hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300" data-testid={`benefit-card-${i}`}>
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy-900 text-gold-400">
                    <Icon size={24} strokeWidth={1.8} aria-hidden />
                  </span>
                  <h3 className="mt-4 font-display text-lg font-semibold text-navy-900">{item.title}</h3>
                  <p className="mt-2 text-base text-charcoal-700 leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
